module.exports = __webpack_public_path__ + "static/media/mask_green.b72baff6.svg";